export default __webpack_public_path__ + "static/media/2.73ea58d7.jpg";